import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Popover as AntPopover } from "antd";
import "antd/es/popover/style/css";

import styles from "./popover.css";

export function Popover(props) {
  const {
    children,
    showArrow,
    targetRenderer,
    position,
    className,
    isOpen,
    trigger = [POPOVER_TRIGGERS.CLICK],
    getContainer = () => document.body,
    destroyOnClose = true,
    onOpen,
    align = {},
    arrowPointAtCenter = true,
    onClose
  } = props;
  const [isVisibile, setIsVisible] = useState(isOpen);
  useEffect(
    function visibleStateUpdatingEvent() {
      setIsVisible(isOpen);
    },
    [isOpen]
  );
  const closePopup = () => {
    setIsVisible(false);
  };

  const getPosition = (position) => {
    const rtlPosition = {
      top: "top",
      topLeft: "topRight",
      topRight: "topLeft",
      leftTop: "rightTop",
      left: "right",
      leftBottom: "rightBottom",
      rightTop: "leftTop",
      right: "left",
      rightBottom: "leftBottom",
      bottomLeft: "bottomRight",
      bottom: "bottom",
      bottomRight: "bottomLeft"
    };
    return window.isRTL ? rtlPosition[position] : position;
  };

  return (
    <AntPopover
      content={children}
      showArrow={showArrow}
      placement={getPosition(position)}
      trigger={trigger}
      visible={isVisibile}
      arrowPointAtCenter={arrowPointAtCenter}
      getPopupContainer={getContainer}
      onVisibleChange={(visible) => {
        setIsVisible(visible);
        if (visible) {
          onOpen && onOpen();
        } else {
          onClose && onClose();
        }
      }}
      overlayClassName={`${styles.popover} ${className}`}
      destroyTooltipOnHide={destroyOnClose}
      align={align}
    >
      {targetRenderer({ closePopup })}
    </AntPopover>
  );
}

Popover.propTypes = {
  children: PropTypes.node,
  showArrow: PropTypes.bool,
  isOpen: PropTypes.bool,
  targetRenderer: PropTypes.func,
  position: PropTypes.string,
  className: PropTypes.string,
  trigger: PropTypes.arrayOf(PropTypes.string),
  getContainer: PropTypes.func,
  popupClassName: PropTypes.string,
  destroyOnClose: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  arrowPointAtCenter: PropTypes.bool,
  align: PropTypes.object
};

export const POPOVER_POSITIONS = {
  TOP: "top",
  TOP_LEFT: "topLeft",
  TOP_RIGHT: "topRight",
  LEFT_TOP: "leftTop",
  LEFT: "left",
  LEFT_BOTTOM: "leftBottom",
  RIGHT_TOP: "rightTop",
  RIGHT: "right",
  RIGHT_BOTTOM: "rightBottom",
  BOTTOM_LEFT: "bottomLeft",
  BOTTOM: "bottom",
  BOTTOM_RIGHT: "bottomRight"
};

export const POPOVER_TRIGGERS = {
  HOVER: "hover",
  FOCUS: "focus",
  CLICK: "click",
  CONTEXT_MENU: "contextMenu"
};
